import styled from 'styled-components'
import InputMd from "./component";

export default styled(InputMd)`
`;